// extracted by mini-css-extract-plugin
export default {"ticket":"_7lIip","discount":"_30UCe","row":"AQBs7","name":"dJ_oG","singlePrice":"_3LbY0","price":"_3bbJN","quantity":"_3YX3W","total":"_3iOR6","priceItem":"_1SKAN"};